import { commonConstantTexts } from 'constants/constantText';
import moment from 'moment';

export const formatChatDate = (time: string | Date): string => {
  const date = moment(time);

  // Check if the date is valid
  if (!date.isValid()) {
    return 'Invalid date';
  }

  return `${date.format(commonConstantTexts.dateFormat)} ${date.format(
    'hh:mm A',
  )}`;
};
